export const analyticsSources = {
  accountPage: "account_page",
  api: "api",
  cliLoginPage: "cli_login_page",
  coworldPlay: "coworld_play",
  coworldPreview: "coworld_preview",
  footer: "footer",
  homepage: "homepage",
  jobsPage: "jobs_page",
  observatoryNavbar: "observatory_navbar",
  observatoryV2: "observatory_v2",
  siteNavAccountMenu: "site_nav_account_menu",
  startWizard: "start_wizard",
  watch: "watch",
} as const;
